import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { clearStateHistoryAction } from '../../../utilities/stateHistory/stateHistorySlice';

//store functions
import { initTouristESim, resetBlock } from './touristESimBlockSlice';

//pages
import InformationPage from './Pages/InformationPage';
import PackagePage from './Pages/PackagePage';
import PaymentPage from './Pages/PaymentPage';
import EsimScanPage from './Pages/EsimScanPage';

const TouristESim = (props) => {
  let currentView = null;

  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initTouristESim({ touristESimBlock: props.iContent });
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  useClearStateResetFlag();

  switch (props.page) {
    case 'informationPage':
      currentView = <InformationPage context={props.context} />;
      break;
    case 'packagePage':
      currentView = <PackagePage context={props.context} />;
      break;
    case 'paymentPage':
      currentView = <PaymentPage context={props.context} />;
      break;
    case 'esimScanPage':
      currentView = <EsimScanPage context={props.context} />;
      break;
  }

  return (
    <div className='tourist-esim-block'>{currentView}</div>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.touristESimBlock.page,
  };
};

const mapDispatchToProps = { initTouristESim, resetBlock };

export default connect(mapStateToProps, mapDispatchToProps)(TouristESim);
